import { render, staticRenderFns } from "./ThanhTichHuyHieuForm.vue?vue&type=template&id=2cebb95e&"
import script from "./ThanhTichHuyHieuForm.vue?vue&type=script&lang=js&"
export * from "./ThanhTichHuyHieuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports